import * as types from "../constants";

const initialState = {
  isLoading: false,
  error: null,
  items: [],
};

export default function libraryUploadFileReducer(state = initialState, action) {
  switch (action.type) {
    case types.LIBRARY_UPLOAD_FILE_INIT:
      return { ...state, error: null, isLoading: true };

    case types.LIBRARY_UPLOAD_FILE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        items: action.data.data,
        error: action.data.error,
      };

    case types.LIBRARY_UPLOAD_FILE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.notification.system_message,
      };

    default:
      return state;
  }
}
